export const packagingUomData: any = [
  {
    uom: 'EA',
    title: 'Smallest Pack (Consumer Level)'
  },
  {
    uom: 'PK',
    title: 'Inner Pack (shippable)'
  },
  {
    uom: 'BX',
    title: 'Inner Pack (non-shippable)'
  },
  {
    uom: 'CA',
    title: 'Case'
  },
  {
    uom: 'PL',
    title: 'Pallet'
  },
];
